import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import { useInView } from 'react-intersection-observer';
import Link from '../Link';

const Component = ({ url = '', className = '', children }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <Styles className={`card-coupon ${className}`} ref={ref}>
      {children}
      <Link to={url} isExternal newTab>
        Printable blank coupons
      </Link>
    </Styles>
  );
};

Component.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Component;
